import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { useWindowScroll } from "react-use";
import styles from "./ContentContainer.module.css";

export interface ContentContainerProps {
  className?: string;
  children: React.ReactNode;
  ref?: any;
  height?: string;
  background?: string;
}

const _ContentContainer = ({
  background,
  height,
  className,
  children,
  ...props
}: ContentContainerProps) => {
  const { y } = useWindowScroll();
  const [isScrolled, setIsScrolled] = useState<boolean>(false);
  const Background = background ? background : "rgba(250, 250, 250, 1)";

  useEffect(() => {
    if (className !== "forHero") {
      const condition = y > window.innerHeight / 2;
      condition !== isScrolled && setIsScrolled(condition);
    }
  }, [y]);

  return (
    <div
      style={{ minHeight: height ? height : '100vh', background: Background }}
      className={classNames(
        styles.contentcontainer,
        isScrolled && styles.scrolled,
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export const ContentContainer = React.memo(_ContentContainer);
